import { render, staticRenderFns } from "./AnnouncementCreateEditModal.vue?vue&type=template&id=92a20fe2&"
import script from "./AnnouncementCreateEditModal.vue?vue&type=script&lang=js&"
export * from "./AnnouncementCreateEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports